import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch((e) => {
        navigate("/admin/login", { replace: true, state: { error: formatApiError(e, "Google sign-in failed.") } });
      });
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bone" data-testid="auth-callback-loading">
      <Loader2 className="h-8 w-8 animate-spin text-stone-400" />
    </div>
  );
}
